import { IdentityApplicantsGet200ResponseInnerStatusEnum } from 'lib/internal/epa/gen';
import ButtonLink from 'src/components/atoms/ButtonLink';
import Tag from 'src/components/atoms/Tag';
import Text from 'src/components/atoms/Text';
import { getIdentityVerificationResultStatusColorTag } from 'src/features/identityVerification/helpers';
import styled from 'styled-components/macro';

export const Header = styled.div`
  display: flex;
  padding-left: 5px;

  & > div {
    margin-right: 6rem;
    margin-bottom: 0.75rem;
  }
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  width: 180px;

  & > div {
    margin-right: 1rem;
  }

  & > h4 {
    color: ${({ theme }) => theme.color.gray[900]};
  }
`;

export const StyledText = styled(Text)`
  min-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline;
`;

export const StyledButton = styled(ButtonLink)`
  justify-content: center;
  font-weight: 500;
  font-size: 0.875rem;
  gap: 0.75rem;
`;

export const Content = styled.div`
  width: 100%;
  padding: 0 30px;
`;

export const StyledTag = styled(Tag).attrs((attrs) => ({
  label: attrs.label,
  color: getIdentityVerificationResultStatusColorTag(
    attrs.label as IdentityApplicantsGet200ResponseInnerStatusEnum
  ),
  showBackground: true
}))``;

export const MenuButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[100]};
  }

  &:active {
    background-color: ${({ theme }) => theme.color.gray[200]};
  }
`;

export const ActionsMenu = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  background: white;
  border: 1px solid ${({ theme }) => theme.color.gray[300]};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  margin-top: 4px;
`;

export const MenuItem = styled.button`
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[900]};
  transition: background-color 0.2s;

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[50]};
  }

  &:active {
    background-color: ${({ theme }) => theme.color.gray[100]};
  }
`;
